<div class="d-flex justify-content-between align-items-center mb-3">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mt-2 mb-0">
      <li class="breadcrumb-item active" aria-current="page">
        Translation errors ({{ messages.length }})
      </li>
    </ol>
  </nav>
  <div class="d-flex gap-2">
    <button class="btn btn-primary fw-bold" (click)="fetchAll()"><i
      class="bi bi-bootstrap-reboot me-2"></i>Refresh
    </button>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
        <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
          <th>Domain</th>
          <th tableSorterHeader="locale">Locale</th>
          <th tableSorterHeader="key">Key</th>
          <th>Error</th>
          <th>Line</th>
          <th>Column</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
          @for (message of messages; track message) {
            <tr>
              <td>{{ message.domain?.domain }}</td>
              <td>
                @if (message.locale) {
                  <img [ngSrc]="langService.getFlag(message.locale)"
                       [alt]="message.locale" width="24" height="24" class="me-1">
                }
              </td>
              <td>{{ message.key }}</td>
              <td>{{ message.error?.message }}</td>
              <td>{{ message.error?.line }}</td>
              <td>{{ message.error?.column }}</td>
              <td>
                <button (click)="edit(message)" class="btn btn-sm btn-primary" type="button">
                  <i class="bi bi-pencil"></i>
                </button>
                <a
                  [href]="'/translation/translations/' + $safeNavigationMigration(message.domain?.id)+'?error=' + message.locale + '-' + message.key"
                  target="_blank"
                  class="btn btn-sm btn-outline-primary ms-1"><i class="bi bi-eye"></i>
                </a>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
